import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Literal class map — see IdTile.jsx for why: Tailwind's scanner needs the
// full class string to exist verbatim in source, not built from a variable.
const TONE_CLASSES = {
	accent: 'tw:bg-accent',
	ok: 'tw:bg-ok',
	danger: 'tw:bg-danger',
};

/**
 * `.prog` — 6px progress bar (cuotas pagadas/total, depreciation, etc.).
 * `value`/`max` are counts, not a percent — the percent is derived here.
 * `accent` (a CSS var name, e.g. '--color-cat-1') overrides `tone` with an
 * inline fill color, for callers whose bar must match a per-item module
 * color rather than one of the three fixed tones.
 */
function ProgressBar({ value, max, tone = 'accent', accent }) {
	const percent = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
	return (
		<div
			className='tw:h-1.5 tw:w-full tw:overflow-hidden tw:rounded-full tw:bg-surface-3'
			role='progressbar'
			aria-valuenow={value}
			aria-valuemin={0}
			aria-valuemax={max}
		>
			<div
				className={classnames('tw:h-full tw:rounded-full', !accent && TONE_CLASSES[tone])}
				style={{ width: `${percent}%`, ...(accent ? { background: `var(${accent})` } : null) }}
			/>
		</div>
	);
}

ProgressBar.propTypes = {
	value: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	tone: PropTypes.oneOf(['accent', 'ok', 'danger']),
	accent: PropTypes.string,
};

export default ProgressBar;
